import { http } from 'interfaces'

export interface CaucusCode {
  id: number
  code: string
  name: string
}

export interface CaucusCodeParams {
  chamber?: number
  state?: number
}

export async function getCaucusCodes (params?: CaucusCodeParams | number): Promise<CaucusCode[]> {
  const queryParams = typeof params === 'number'
    ? { chamber: params }
    : params ?? {}

  return await http.get('/api/v1/us/committee/caucuscodes', { params: queryParams })
    .then(response => response.data)
    .catch(error => {
      console.error('Error fetching caucus codes:', error)
      return []
    })
}

export interface CommitteeCode {
  id: number
  code: string
  name: string
}

export interface CommitteeCodeParams {
  chamber?: number
  state?: number
}

export async function getCommitteeCodes (params?: CommitteeCodeParams | number): Promise<CommitteeCode[]> {
  const queryParams = typeof params === 'number'
    ? { chamber: params }
    : params ?? {}

  return await http.get('/api/v1/us/committee/committeecodes', { params: queryParams })
    .then(response => response.data)
    .catch(error => {
      console.error('Error fetching committee codes:', error)
      return []
    })
}
